/* Meldora Kitchen: photo slideshow + mobile sticky buy bar. No dependencies. */
(function () {
  'use strict';

  function initGallery(root) {
    root.querySelectorAll('[data-mk-gallery]').forEach(function (g) {
      if (g.dataset.mkReady) return;
      g.dataset.mkReady = '1';
      var track = g.querySelector('[data-mk-track]');
      if (!track) return;
      var slides = track.children;
      var thumbs = g.querySelectorAll('[data-mk-thumb]');
      var current = g.querySelector('[data-mk-current]');
      var prev = g.querySelector('[data-mk-prev]');
      var next = g.querySelector('[data-mk-next]');
      var index = 0;

      function go(i) {
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      function sync() {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (i === index) return;
        index = Math.max(0, Math.min(slides.length - 1, i));
        if (current) current.textContent = index + 1;
        thumbs.forEach(function (t, n) {
          if (n === index) {
            t.setAttribute('aria-current', 'true');
            var strip = t.parentElement;
            var left = t.offsetLeft - strip.offsetLeft;
            if (left < strip.scrollLeft || left + t.offsetWidth > strip.scrollLeft + strip.clientWidth) {
              strip.scrollTo({ left: left - 8, behavior: 'smooth' });
            }
          } else {
            t.removeAttribute('aria-current');
          }
        });
      }
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(sync);
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(parseInt(t.dataset.mkThumb, 10)); });
      });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      });
    });
  }

  function initSticky(root) {
    root.querySelectorAll('[data-mk-sticky]').forEach(function (bar) {
      if (bar.dataset.mkReady) return;
      bar.dataset.mkReady = '1';
      var main = document.querySelector('product-form');
      var footer = document.querySelector('.footer, footer');
      var past = false;
      var nearFooter = false;
      function update() {
        var show = past && !nearFooter;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.querySelectorAll('button, a').forEach(function (n) { n.tabIndex = show ? 0 : -1; });
      }
      if (!main) { update(); return; }
      var ticking = false;
      function measure() {
        ticking = false;
        past = main.getBoundingClientRect().bottom < 0;
        update();
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(measure); }
      }, { passive: true });
      window.addEventListener('resize', measure);
      measure();
      if (footer && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          nearFooter = entries[0].isIntersecting;
          update();
        }).observe(footer);
      }
      var proxy = bar.querySelector('[data-mk-proxy-add]');
      if (proxy) {
        proxy.addEventListener('click', function () {
          var btn = main.querySelector('[name="add"]');
          if (btn && !btn.disabled) btn.click();
          else main.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
      update();
    });
  }

  function init(root) {
    initGallery(root || document);
    initSticky(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
